var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMerge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#F7C5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12H8.4C7.26863 12 6.70294 12 6.35147 12.3515C6 12.7029 6 13.2686 6 14.4V15.6C6 16.7314 6 17.2971 6.35147 17.6485C6.70294 18 7.26863 18 8.4 18H9.6C10.7314 18 11.2971 18 11.6485 17.6485C12 17.2971 12 16.7314 12 15.6V15",
    stroke: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7695 8.76929H11.1695C10.0382 8.76929 9.47248 8.76929 9.121 9.12076C8.76953 9.47223 8.76953 10.0379 8.76953 11.1693V12.3693C8.76953 13.5007 8.76953 14.0663 9.121 14.4178C9.47248 14.7693 10.0382 14.7693 11.1695 14.7693H12.3695C13.5009 14.7693 14.0666 14.7693 14.4181 14.4178C14.7695 14.0663 14.7695 13.5007 14.7695 12.3693V11.7693",
    stroke: "#1D1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.4C12 7.26863 12 6.70294 12.3515 6.35147C12.7029 6 13.2686 6 14.4 6H15.6C16.7314 6 17.2971 6 17.6485 6.35147C18 6.70294 18 7.26863 18 8.4V9.6C18 10.7314 18 11.2971 17.6485 11.6485C17.2971 12 16.7314 12 15.6 12H14.4C13.2686 12 12.7029 12 12.3515 11.6485C12 11.2971 12 10.7314 12 9.6V8.4Z",
    stroke: "#1D1D1D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMerge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/merge.e397249b1d23dde983e29ef827a718d9.svg";